import { useCustomerBrandHotelSelection } from 'components/customerBrandHotelSelect/useCustomerBrandHotelSelection';
import { includes } from 'lodash';
import { useRequest, UseRequestHook } from 'redux-query-react';
import { getHeaders } from '../helpers/request/getHeaders';

export const useRequestWithAuth: UseRequestHook = (request) => {
    const { selectedClient } = useCustomerBrandHotelSelection();
    if (!request) {
        return useRequest(request);
    }
    if (!!request.url && selectedClient && selectedClient.id) {
        if (includes(request.url, '?')) {
            request.url += '&selectedClientId=' + selectedClient.id;
        } else {
            request.url += '?selectedClientId=' + selectedClient.id;
        }
    }
    const withHeaders = {
        ...request,
        options: {
            ...request.options,
            headers: getHeaders(),
        },
    };
    return useRequest(withHeaders);
};
